var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_3668_706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9109 15.7691C18.0255 15.7691 21.3609 12.4337 21.3609 8.31914C21.3609 4.20462 18.0255 0.869141 13.9109 0.869141C9.79642 0.869141 6.46094 4.20462 6.46094 8.31914C6.46094 12.4337 9.79642 15.7691 13.9109 15.7691Z",
    stroke: "#193243",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9111 18.5996C6.73109 18.5996 0.871094 22.1096 0.871094 26.3696V30.3096H26.9411V26.3696C26.9411 22.1096 21.0311 18.5996 13.9011 18.5996H13.9111Z",
    stroke: "#193243",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3668_706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.82,
    height: 31.18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileimg);
export default __webpack_public_path__ + "static/media/profileimg.bc5a8474ead39845e1c88d1b7a81cb29.svg";
export { ForwardRef as ReactComponent };